'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalDispatcher = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactRedux = require('react-redux');

var _actions = require('./actions');

var _reducers = require('./reducers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cloneChild = function cloneChild(activeModals) {
  return function (child) {
    return activeModals[child.props.id] && _react2['default'].cloneElement(child, _actions.options[child.props.id].params);
  };
};

var state2Props = function state2Props(state) {
  return { activeModals: (0, _reducers.getActiveModals)(state) };
};

var ModalDispatcher = exports.ModalDispatcher = (0, _reactRedux.connect)(state2Props)(function (_ref) {
  var children = _ref.children,
      activeModals = _ref.activeModals;
  return _react2['default'].createElement(
    'div',
    { className: 'combine-modals-wrapper' },
    _react.Children.map(children, cloneChild(activeModals))
  );
});

ModalDispatcher.propTypes = {
  children: _propTypes.PropTypes.any, // from JSX
  options: _propTypes.PropTypes.object, // from ../actions
  activeModals: _propTypes.PropTypes.object // from state
};